import { PropsWithChildren, ReactElement } from "react";
import classNames from "classnames";
import {
  getBusinessName,
  getCardholder,
  getCvc,
  getExpirationDateString,
  getFullPan,
  getCardSignatureUri,
} from "/src/util/card-v2";
import { CardPreview } from "../card/CardPreview";
import styles from "./PreviewContentCard.css";
import { Card } from "/src/protos/squareup/bbdebit/cardmanagement";
import { CardCustomization } from "/src/protos/squareup/bizbank/service";

export interface PreviewContentCardProps {
  readonly card: Card;
  readonly cardCustomization?: CardCustomization;
  readonly showCardDetails?: boolean;
  readonly previewSecondaryContent?: ReactElement;
}

export function PreviewContentCard({
  card,
  cardCustomization,
  children,
  showCardDetails = false,
  previewSecondaryContent,
}: PropsWithChildren<PreviewContentCardProps>) {
  const previewContainerClassName =
    previewSecondaryContent == null
      ? styles.previewContainer
      : classNames(styles.previewContainer, styles.previewContainerWithSecondary);
  return (
    <div className={styles.container}>
      <div className={previewContainerClassName}>
        <div className={styles.preview}>
          {/*TODO: replace with real business name*/}
          <CardPreview
            cardholder={getCardholder(card)}
            cvc={getCvc(card)}
            expirationDate={getExpirationDateString(card)}
            fullPan={getFullPan(card)}
            businessName={getBusinessName(card)}
            showCardDetails={showCardDetails}
            signatureDataUri={getCardSignatureUri(cardCustomization)}
          />
          {previewSecondaryContent}
        </div>
      </div>
      {children ? <div className={styles.listContainer}>{children}</div> : null}
    </div>
  );
}
